
import gsap, { Power4, Back } from "gsap";
import { ref, defineComponent } from "vue";
import { HTMLElementEvent } from "../types";
import { useUser } from "../utils/composable/useUser";
export default defineComponent({
  name: "Navbar",
  setup() {
    const { isLoggedIn } = useUser();
    const activeRoute = ref(1);

    const tilt = (e: HTMLElementEvent) => {
      if (e.target.classList.contains("tab__item")) {
        gsap.to(e.target, {
          scale: 0.7,
          rotate: "10deg",
          ease: Power4.easeOut,
          duration: 0.4,
        });
      }
    };

    const activateRoute = (e: HTMLElementEvent) => {
      const items = document.querySelectorAll(".tab__item");

      if (e.target.classList.contains("tab__item")) {
        items.forEach((item) => item.classList.remove("tab__item--active"));
        e.target.classList.add("tab__item--active");

        gsap.to(e.target, {
          scale: 1,
          rotate: 0,
          ease: Back.easeOut.config(5),
        });
      }
    };

    return {
      activeRoute,
      activateRoute,
      tilt,
      isLoggedIn,
    };
  },
});
